import React, { useState, useEffect } from 'react';
import styled, { keyframes } from 'styled-components';
import { useNavigate as useRouterNavigate, useLocation as useRouterLocation, Outlet } from 'react-router-dom';
import Logo from '../components/common/Logo';
import CryptoTicker from '../components/crypto/CryptoTicker'; 
import { useCryptoStore, CryptoPrice } from '../store/cryptoStore'; 
import { useAuth } from '../contexts/AuthContext'; 
import axios from '../utils/axiosConfig';



const MenuItem = styled.div<{ $isActive?: boolean }>`
  display: flex;
  align-items: center;
  gap: 16px;
  padding: 12px;
  border-radius: 12px;
  cursor: pointer;
  position: relative;
  color: ${props => props.$isActive ? '#3B82F6' : '#E2E8F0'};
  background: ${props => props.$isActive ? 'rgba(59, 130, 246, 0.1)' : 'transparent'};
  transition: all 0.3s ease;

  &:hover {
    background: rgba(59, 130, 246, 0.1);
    transform: translateX(5px);
  }
`;

const NavSection = styled.nav`
  display: flex;
  flex-direction: column;
  gap: 8px;
  padding: 16px;
  height: calc(100% - 80px);
  justify-content: space-between;
`;

const MenuGroup = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
`;

const LogoutMenuItem = styled(MenuItem)`
  border-top: 1px solid rgba(255, 255, 255, 0.1);
  padding-top: 16px;
  color: #EF4444;
  
  &:hover {
    background: rgba(239, 68, 68, 0.1);
  }
`;

const UnreadBadge = styled.div`
    position: absolute;
    top: -5px;
    right: -5px;
    background-color: #ef4444;
    color: white;
    border-radius: 50%;
    min-width: 18px;
    height: 18px;
    padding: 0 4px;
    font-size: 12px;
    display: flex;
    align-items: center;
    justify-content: center;
    font-weight: bold;
    box-shadow: 0 0 0 2px #1a1a1f;
`;


interface BackButtonProps {
  $sidebarOpen: boolean;
}

const BackButton = styled.button<BackButtonProps>`
  position: fixed;
  top: 80px;
  left: ${props => props.$sidebarOpen ? '300px' : '100px'};
  padding: 10px 20px;
  background-color: #2c3e50;
  color: white;
  border: none;
  border-radius: 5px;
  cursor: pointer;
  display: flex;
  align-items: center;
  gap: 8px;
  transition: all 0.3s ease;
  z-index: 1000;

  &:hover {
    background-color: #34495e;
    transform: translateY(-2px);
  }
`;






const DashboardLayout: React.FC = () => {
    const navigate = useRouterNavigate(); // Değişti
    const location = useRouterLocation(); // Değişti
        const [isSidebarOpen, setIsSidebarOpen] = useState(true);
        const [unreadSignals, setUnreadSignals] = useState(0);
    const [cryptoPrice, setCryptoPrice] = useState(45000);
    const { getFavorites, toggleFavorite, setSelectedChart, prices } = useCryptoStore();
    const favorites = getFavorites();
    const { logout, user, isAuthenticated } = useAuth(); 
    






    useEffect(() => {
      fetchUnreadSignalsCount(); // İlk yükleme
      const interval = setInterval(fetchUnreadSignalsCount, 5000);
      return () => clearInterval(interval);
  }, []); 



  const fetchUnreadSignalsCount = async () => {
    try {
        const response = await axios.get('/api/signals/unread-count');
        console.log('Bildirim response detayı:', {
            data: response.data,
            count: response.data.count,
            typeofCount: typeof response.data.count
        });
        
        if (response.data && typeof response.data.count === 'number') {
            setUnreadSignals(response.data.count);
        } else {
            console.error('Geçersiz response format:', response.data);
        }
    } catch (error) {
        console.error('Okunmamış sinyal sayısı alınamadı:', error);
    }
};


useEffect(() => {
  console.log('unreadSignals değeri:', unreadSignals); // State değişimini kontrol et
}, [unreadSignals]);


  const getTopMovers = () => {
    if (!prices) return { gainers: [], losers: [] };

    const priceArray = Object.values(prices);
    const sorted = priceArray.sort((a: CryptoPrice, b: CryptoPrice) => 
      Math.abs(b.priceChange) - Math.abs(a.priceChange)
    );

    const gainers = sorted
      .filter((coin: CryptoPrice) => coin.priceChange > 0)
      .slice(0, 10);
      
    const losers = sorted
      .filter((coin: CryptoPrice) => coin.priceChange < 0)
      .slice(0, 10);

    return { gainers, losers };
  };

  const { gainers, losers } = getTopMovers();



  const handleFavoriteClick = async (symbol: string) => {
    try {
      if (!isAuthenticated) {
        alert('Favorilere eklemek için giriş yapmalısınız!');
        return;
      }
      const symbolWithoutUSDT = symbol.replace('USDT', '');
      await toggleFavorite(symbol + 'USDT', symbolWithoutUSDT);
    } catch (error) {
      console.error('Favori işlemi sırasında hata:', error);
      alert('Favori işlemi sırasında bir hata oluştu');
    }
  };


  const handleLogout = async () => {
    try {
      await logout();
      // logout fonksiyonu zaten yönlendirmeyi yapıyor
    } catch (error) {
      console.error('Çıkış yapılırken hata oluştu:', error);
      alert('Çıkış yapılırken bir hata oluştu. Lütfen tekrar deneyin.');
    }
  };




  const handleDeleteAll = async () => {
    if (window.confirm('Tüm sinyalleri silmek istediğinizden emin misiniz?')) {
      try {
        const response = await axios.delete('/api/signals/delete-all');
        console.log(response.data.message);
        // Sinyalleri yeniden yükle
        fetchUnreadSignalsCount();
      } catch (error) {
        console.error('Sinyaller silinirken hata:', error);
        alert('Sinyaller silinirken bir hata oluştu');
      }
    }
  };
  





  return (
    <Container>
      <Navbar>
        <NavbarLeft>
        Hoş Geldiniz, {user?.username || 'Misafir'} {/* [object Object] yerine username'i göster */}
        </NavbarLeft>
        <NavbarRight>
          <LogoutButton onClick={handleLogout}>
            <LogoutIcon>🚪</LogoutIcon>
            Oturumu Kapat
          </LogoutButton>
        </NavbarRight>
      </Navbar>
        
      <MainWrapper>
        <Sidebar $isOpen={isSidebarOpen}>
          <SidebarContent>
            <LogoSection>
              <LogoWrapper>
                <Logo />
              </LogoWrapper>
              <MenuToggle 
                onClick={() => setIsSidebarOpen(!isSidebarOpen)}
                $isOpen={isSidebarOpen}
              >
                {isSidebarOpen ? '◀' : '▶'}
              </MenuToggle>
            </LogoSection>
  




            <NavSection>
    <MenuGroup>

    <MenuItem 
    $isActive={location.pathname === '/dashboard/signals'}
    onClick={() => navigate('/dashboard/signals')}
>
    <IconBox>
        <Icon>🔔</Icon>
        <IconRing />
        <GlowEffect />
        {unreadSignals > 0 ? (
            <UnreadBadge>{unreadSignals}</UnreadBadge>
        ) : null}
    </IconBox>
    <MenuLabel $isOpen={isSidebarOpen}>Gelen Sinyal</MenuLabel>
    {location.pathname === '/dashboard/signals' && <ActiveBar />}
</MenuItem>


        <MenuItem 
    style={{ opacity: 0.7, cursor: 'not-allowed' }}
>
    <IconBox>
        <Icon>🎯</Icon>
        <IconRing />
        <PulseEffect />
    </IconBox>
    <MenuLabel $isOpen={isSidebarOpen}>Akıllı Sinyal</MenuLabel>
    <ComingSoonMessage>Bu özellik yakında eklenecek</ComingSoonMessage>
</MenuItem>

<MenuItem 
    style={{ opacity: 0.7, cursor: 'not-allowed' }}
>
    <IconBox>
        <Icon>⚙️</Icon>
        <IconRing />
        <GlowEffect />
    </IconBox>
    <MenuLabel $isOpen={isSidebarOpen}>Sinyal Ayarları</MenuLabel>
    <ComingSoonMessage>Bu özellik yakında eklenecek</ComingSoonMessage>
</MenuItem>

<MenuItem
    style={{ opacity: 0.7, cursor: 'not-allowed' }}
>
    <IconBox>
        <Icon>⚙️</Icon>
        <IconRing />
        <GearEffect />
    </IconBox>
    <MenuLabel $isOpen={isSidebarOpen}>Genel Ayarlar</MenuLabel>
    <ComingSoonMessage>Bu özellik yakında eklenecek</ComingSoonMessage>
</MenuItem>
    </MenuGroup>
</NavSection>


          </SidebarContent>
        </Sidebar>

        
        <MainContent $sidebarOpen={isSidebarOpen}>
  {location.pathname === '/dashboard' || location.pathname === '/dashboard/portfoy' ? (
    <ContentArea>
      <GridLayout>
        <Card>
          <CardTitle>Market Özeti</CardTitle>
          <MarketOverview>
            <TopMoversSection>
              <SubTitle>En Çok Kazananlar <GainIcon>📈</GainIcon></SubTitle>
              <MoversList>
                {gainers.map((coin: CryptoPrice) => (
                  <MoverItem key={coin.symbol} $isGainer={true}>
                    <CoinInfo>
                      <CoinSymbol>{coin.symbol}/USDT</CoinSymbol>
                      <CoinPrice>
                        ${coin.price.toLocaleString(undefined, {
                          minimumFractionDigits: 2,
                          maximumFractionDigits: 6
                        })}
                      </CoinPrice>
                    </CoinInfo>
                    <PriceChange $isUp={true}>
                      +{coin.priceChange.toFixed(2)}%
                    </PriceChange>
                    <ButtonGroup>
                      <ChartButton 
                        onClick={() => setSelectedChart(coin.symbol)}
                        title="Grafiği Göster"
                      >
                        📈
                      </ChartButton>
                      <FavoriteButton
                        onClick={() => handleFavoriteClick(coin.symbol)}
                        $isFavorite={favorites.some(f => f.symbol === coin.symbol)}
                        disabled={!isAuthenticated}
                        title={isAuthenticated ? 'Favorilere Ekle/Çıkar' : 'Giriş Yapın'}
                      >
                        {favorites.some(f => f.symbol === coin.symbol) ? '★' : '☆'}
                      </FavoriteButton>
                    </ButtonGroup>
                  </MoverItem>
                ))}
              </MoversList>
            </TopMoversSection>

            <TopMoversSection>
              <SubTitle>En Çok Kaybedenler <LossIcon>📉</LossIcon></SubTitle>
              <MoversList>
                {losers.map((coin: CryptoPrice, index: number) => (
                  <MoverItem key={coin.symbol} $isGainer={false}>
                    <CoinInfo>
                      <CoinSymbol>{coin.symbol}/USDT</CoinSymbol>
                      <CoinPrice>
                        ${coin.price.toLocaleString(undefined, {
                          minimumFractionDigits: 2,
                          maximumFractionDigits: 6
                        })}
                      </CoinPrice>
                    </CoinInfo>
                    <PriceChange $isUp={false}>
                      {coin.priceChange.toFixed(2)}%
                    </PriceChange>
                    <ChartButton 
                      onClick={() => setSelectedChart(coin.symbol)}
                      title="Grafiği Göster"
                    >
                      📈
                    </ChartButton>
                  </MoverItem>
                ))}
              </MoversList>
            </TopMoversSection>
          </MarketOverview>
        </Card>

        <Card>
          <CardTitle>Favoriler ({favorites.length})</CardTitle>
          <SignalsList>
            {favorites.length > 0 ? (
              favorites.map((coin, i) => (
                <SignalItem key={coin.symbol} $delay={i * 0.1}>
                  <SignalIcon>⭐</SignalIcon>
                  <SignalInfo>
                    <SignalName>{coin.symbol}/USDT</SignalName>
                    <SignalPrice $isUp={coin.priceChange >= 0}>
                      ${coin.price.toLocaleString()}
                    </SignalPrice>
                  </SignalInfo>
                  <ButtonGroup>
                    <ChartButton 
                      onClick={(e) => {
                        e.stopPropagation();
                        setSelectedChart(coin.symbol.replace('USDT', ''));
                      }}
                      title="Grafiği Göster"
                    >
                      📈
                    </ChartButton>
                    <RemoveFavorite 
                      onClick={(e) => {
                        e.stopPropagation();
                        toggleFavorite(coin.symbol + 'USDT', coin.symbol);
                      }}
                      title="Favorilerden Çıkar"
                    >
                      ✖
                    </RemoveFavorite>
                  </ButtonGroup>
                  <SignalIndicator $isUp={coin.priceChange >= 0} />
                </SignalItem>
              ))
            ) : (
              <EmptyFavorites>
                <EmptyIcon>⭐</EmptyIcon>
                <EmptyText>
                  Henüz favori coin eklemediniz. 
                  Coinlerin yanındaki yıldız işaretine tıklayarak favorilerinize ekleyebilirsiniz.
                </EmptyText>
              </EmptyFavorites>
            )}
          </SignalsList>
        </Card>

        <Card>
          <CardTitle>Canlı Kripto Fiyatları</CardTitle>
          <CryptoTicker />
        </Card>
        </GridLayout>
    </ContentArea>
  ) : (


<div style={{ position: 'relative', height: '100%' }}>
  <BackButton $sidebarOpen={isSidebarOpen} onClick={() => navigate('/dashboard')}>
    ← Ana Sayfaya Dön
    </BackButton>
  
  <ActionButtons>
    <ActionButton 
      className="delete-all" 
      onClick={() => handleDeleteAll()}
    >
      🗑️ Tümünü Sil
    </ActionButton>
  
  </ActionButtons>
  <Outlet />
</div>


  )}
</MainContent>

    </MainWrapper>
  </Container>
);};




  
// Animasyonlar
const float = keyframes`
  0%, 100% { transform: translateY(0); }
  50% { transform: translateY(-5px); }
`;

const pulse = keyframes`
  0% { transform: scale(1); opacity: 0.5; }
  50% { transform: scale(1.2); opacity: 0.2; }
  100% { transform: scale(1); opacity: 0.5; }
`;



const ActionButtons = styled.div`
  display: flex;
  gap: 12px;
  margin-bottom: 20px;
  padding: 16px;
`;

const ActionButton = styled.button`
  padding: 8px 16px;
  border-radius: 6px;
  border: none;
  cursor: pointer;
  display: flex;
  align-items: center;
  gap: 8px;
  transition: all 0.3s ease;
  font-weight: 500;

  &.delete-all {
    background-color: #ef4444;
    color: white;
    
    &:hover {
      background-color: #dc2626;
    }
  }

  &.mark-all-read {
    background-color: #3b82f6;
    color: white;
    
    &:hover {
      background-color: #2563eb;
    }
  }
`;







const EmptyFavorites = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 12px;
  padding: 24px;
  background: rgba(255, 255, 255, 0.05);
  border-radius: 12px;
  text-align: center;
`;

const NewBadge = styled.span<{ $isOpen: boolean }>`
  background: #EF4444;
  color: white;
  padding: 2px 8px;
  border-radius: 12px;
  font-size: 0.7rem;
  position: absolute;
  right: 16px;
  opacity: ${props => props.$isOpen ? 1 : 0};
  visibility: ${props => props.$isOpen ? 'visible' : 'hidden'};
  transition: all 0.3s ease;
`;

const Navbar = styled.nav`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0 24px;
  height: 64px;
  background: rgba(15, 23, 42, 0.95);
  backdrop-filter: blur(12px);
  border-bottom: 1px solid rgba(255, 255, 255, 0.1);
  z-index: 1000;
`;

const NavbarLeft = styled.div`
  display: flex;
  align-items: center;
  gap: 16px;
`;

const NavbarRight = styled.div`
  display: flex;
  align-items: center;
  gap: 16px;
`;

const WelcomeText = styled.span`
  color: #E2E8F0;
  font-size: 0.9rem;
`;

const UserName = styled.span`
  color: #3B82F6;
  font-weight: 500;
`;

const LogoutButton = styled.button`
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 8px 16px;
  border-radius: 8px;
  border: none;
  background: rgba(239, 68, 68, 0.1);
  color: #EF4444;
  cursor: pointer;
  transition: all 0.3s ease;
  font-size: 0.9rem;

  &:hover {
    background: rgba(239, 68, 68, 0.2);
    transform: translateY(-2px);
  }

  &:active {
    transform: translateY(0);
  }
`;

const LogoutIcon = styled.span`
  font-size: 1.1rem;
`;

const MainWrapper = styled.div`
  display: flex;
  flex: 1;
  height: calc(100vh - 64px);
  margin-top: 64px;
`;




const PulseEffect = styled.div`
  position: absolute;
  inset: -5px;
  border-radius: 50%;
  background: radial-gradient(circle, rgba(239, 68, 68, 0.3) 0%, transparent 70%);
  animation: ${pulse} 2s ease-in-out infinite;
`;

const WaveEffect = styled.div`
  position: absolute;
  inset: 0;
  border: 2px solid rgba(239, 68, 68, 0.3);
  border-radius: 50%;
  animation: ${pulse} 2s ease-in-out infinite;
`;




const EmptyIcon = styled.div`
  font-size: 2rem;
  color: rgba(255, 255, 255, 0.3);
  animation: ${float} 3s ease-in-out infinite;
`;

const EmptyText = styled.p`
  color: rgba(255, 255, 255, 0.5);
  font-size: 0.9rem;
  margin: 0;
  line-height: 1.5;
`;


const ActionButtonGroup = styled.div`  // ButtonGroup -> ActionButtonGroup olarak değişti
  display: flex;
  gap: 8px;
  align-items: center;
`;

const ChartButton = styled.button`
  background: none;
  border: none;
  color: rgba(255, 255, 255, 0.6);
  font-size: 1.2rem;
  cursor: pointer;
  padding: 4px;
  border-radius: 4px;
  transition: all 0.3s ease;

  &:hover {
    color: #3B82F6;
    background: rgba(59, 130, 246, 0.1);
    transform: scale(1.1);
  }

  &:active {
    transform: scale(0.95);
  }
`;

const MarketOverview = styled.div`
  display: flex;
  flex-direction: column;
  gap: 24px;
`;

const TopMoversSection = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
`;

const SubTitle = styled.h3`
  font-size: 1rem;
  color: #E2E8F0;
  display: flex;
  align-items: center;
  gap: 8px;
`;

const GainIcon = styled.span`
  color: #10B981;
`;

const LossIcon = styled.span`
  color: #EF4444;
`;

const MoversList = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
`;

const MoverItem = styled.div<{ $isGainer: boolean }>`
  display: flex;
  align-items: center;
  gap: 16px;
  padding: 12px;
  background: ${props => props.$isGainer ? 
    'rgba(16, 185, 129, 0.1)' : 
    'rgba(239, 68, 68, 0.1)'};
  border-radius: 12px;
  transition: all 0.3s ease;

  &:hover {
    transform: translateX(5px);
    background: ${props => props.$isGainer ? 
      'rgba(16, 185, 129, 0.2)' : 
      'rgba(239, 68, 68, 0.2)'};
  }
`;

const CoinInfo = styled.div`
  flex: 1;
`;

const CoinSymbol = styled.div`
  font-weight: 500;
  color: #E2E8F0;
`;

const CoinPrice = styled.div`
  font-size: 0.9rem;
  color: rgba(255, 255, 255, 0.6);
`;

const PriceChange = styled.div<{ $isUp: boolean }>`
  color: ${props => props.$isUp ? '#10B981' : '#EF4444'};
  font-weight: 500;
  min-width: 80px;
  text-align: right;
`;



const RemoveFavorite = styled.button`
  background: none;
  border: none;
  color: rgba(255, 255, 255, 0.5);
  font-size: 1rem;
  cursor: pointer;
  padding: 4px 8px;
  border-radius: 4px;
  transition: all 0.3s ease;
  margin-right: 8px;

  &:hover {
    color: #EF4444;
    background: rgba(239, 68, 68, 0.1);
    transform: scale(1.1);
  }

  &:active {
    transform: scale(0.95);
  }
`;


const MenuText = styled.span<{ $isOpen: boolean }>`
  margin-left: 16px;
  font-size: 1rem;
  color: #E2E8F0;
  white-space: nowrap;
  opacity: ${props => props.$isOpen ? 1 : 0};
  transition: opacity 0.3s ease;
  width: ${props => props.$isOpen ? 'auto' : '0'};
  visibility: ${props => props.$isOpen ? 'visible' : 'hidden'};
`;


const rotate = keyframes`
  from { transform: rotate(0deg); }
  to { transform: rotate(360deg); }
`;

const sparkle = keyframes`
  0% { transform: scale(1); opacity: 1; }
  50% { transform: scale(1.5); opacity: 0; }
  100% { transform: scale(1); opacity: 1; }
`;

const slide = keyframes`
  from { transform: translateX(0); }
  to { transform: translateX(-100%); }
`;

const glow = keyframes`
  0% { box-shadow: 0 0 5px rgba(59, 130, 246, 0.5); }
  50% { box-shadow: 0 0 20px rgba(59, 130, 246, 0.8); }
  100% { box-shadow: 0 0 5px rgba(59, 130, 246, 0.5); }
`;

const chartAnimation = keyframes`
  0% { transform: scaleY(0.8); }
  50% { transform: scaleY(1.2); }
  100% { transform: scaleY(0.8); }
`;

const priceFlash = keyframes`
  0% { background: rgba(59, 130, 246, 0.1); }
  50% { background: rgba(59, 130, 246, 0.3); }
  100% { background: rgba(59, 130, 246, 0.1); }
`;

const lightning = keyframes`
  0% { opacity: 0; }
  50% { opacity: 1; }
  100% { opacity: 0; }
`;

const spin = keyframes`
  from { transform: rotate(0deg); }
  to { transform: rotate(360deg); }
`;

const particleAnimation = keyframes`
  0% { transform: translate(0, 0); opacity: 1; }
  100% { transform: translate(${() => Math.random() * 50 - 25}px, ${() => Math.random() * 50 - 25}px); opacity: 0; }
`;

// Styled Components
const Container = styled.div`
  display: flex;
  flex-direction: column;
  min-height: 100vh;
  background: #0F172A;
  overflow-x: hidden;
`;

const ComingSoonMessage = styled.div`
    font-size: 11px;
    color: #8b8da0;
    margin-top: 6px;
    font-style: italic;
    opacity: 0.8;
    text-align: right;
    padding-right: 12px;
    letter-spacing: 0.3px;
`;



const Sidebar = styled.aside<{ $isOpen: boolean }>`
  width: ${props => props.$isOpen ? '280px' : '80px'};
  background: rgba(15, 23, 42, 0.8);
  backdrop-filter: blur(12px);
  border-right: 1px solid rgba(255, 255, 255, 0.1);
  transition: width 0.3s ease;
  height: calc(100vh - 64px); // Navbar yüksekliğini çıkar
  position: fixed;
  top: 64px; // Navbar yüksekliği kadar aşağıdan başlat
`;


const SidebarContent = styled.div`
  height: 100%;
  display: flex;
  flex-direction: column;
  padding: 24px 16px;
  gap: 32px;
`;

const LogoSection = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 16px;
  position: relative;
`;


const LogoWrapper = styled.div`
  animation: ${float} 3s ease-in-out infinite;
  z-index: 1; // Logo her zaman üstte olsun
`;

const MenuToggleWrapper = styled.div`
  position: absolute;
  right: 0;
  top: 50%;
  transform: translateY(-50%);
`;
interface MenuToggleProps {
  $isOpen: boolean;
}

const MenuToggle = styled.button<MenuToggleProps>`
  background: rgba(59, 130, 246, 0.1);
  border: 1px solid rgba(59, 130, 246, 0.2);
  color: #60A5FA;
  cursor: pointer;
  width: 32px;
  height: 32px;
  border-radius: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.3s ease;
  position: absolute;
  right: ${props => props.$isOpen ? '16px' : '-16px'};
  top: 80px; // Logo'dan daha aşağıda konumlandır
  z-index: 100;

  &:hover {
    background: rgba(59, 130, 246, 0.2);
    transform: scale(1.1);
  }
`;






const IconBox = styled.div`
  position: relative;
  width: 40px;
  height: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
`;

const Icon = styled.span`
  font-size: 1.4rem;
  z-index: 1;
  animation: ${float} 3s ease-in-out infinite;
`;

const IconRing = styled.div`
  position: absolute;
  inset: 0;
  border: 2px solid rgba(59, 130, 246, 0.3);
  border-radius: 50%;
  animation: ${pulse} 3s ease-in-out infinite;
`;

const MenuLabel = styled.span<{ $isOpen: boolean }>`
  margin-left: 16px;
  font-size: 1rem;
  color: #E2E8F0;
  white-space: nowrap;
  opacity: ${props => props.$isOpen ? 1 : 0};
  transition: opacity 0.3s ease;
  width: ${props => props.$isOpen ? 'auto' : '0'};
  visibility: ${props => props.$isOpen ? 'visible' : 'hidden'};
`;



const ActiveBar = styled.div`
  position: absolute;
  left: 0;
  top: 50%;
  transform: translateY(-50%);
  width: 3px;
  height: 20px;
  background: #3B82F6;
  border-radius: 0 3px 3px 0;
`;

const CryptoParticles = styled.div`
  position: absolute;
  inset: 0;
  pointer-events: none;
`;

const Particle = styled.div<{ $index: number }>`
  position: absolute;
  width: 4px;
  height: 4px;
  background: #3B82F6;
  border-radius: 50%;
  animation: ${particleAnimation} 2s ease-out infinite;
  animation-delay: ${props => props.$index * 0.2}s;
`;

const PriceIndicator = styled.div<{ $isUp: boolean; $isOpen: boolean }>`
  position: absolute;
  right: 16px;
  padding: 4px 8px;
  border-radius: 8px;
  font-size: 0.8rem;
  font-weight: 500;
  color: ${props => props.$isUp ? '#10B981' : '#EF4444'};
  background: ${props => props.$isUp ? 'rgba(16, 185, 129, 0.1)' : 'rgba(239, 68, 68, 0.1)'};
  animation: ${priceFlash} 2s ease-in-out infinite;
  opacity: ${props => props.$isOpen ? 1 : 0};
  visibility: ${props => props.$isOpen ? 'visible' : 'hidden'};
  transition: opacity 0.3s ease, visibility 0.3s ease;
`;


const TradingLine = styled.div`
  position: absolute;
  width: 100%;
  height: 2px;
  background: linear-gradient(90deg, transparent, #3B82F6, transparent);
  bottom: 0;
  animation: ${slide} 2s linear infinite;
`;

const GlowEffect = styled.div`
  position: absolute;
  inset: -5px;
  border-radius: 50%;
  background: radial-gradient(circle, rgba(59, 130, 246, 0.3) 0%, transparent 70%);
  animation: ${pulse} 2s ease-in-out infinite;
`;

const LightningEffect = styled.div`
  position: absolute;
  inset: 0;
  background: radial-gradient(circle, #FFD700 0%, transparent 70%);
  animation: ${lightning} 1s ease-in-out infinite;
`;

const SpinEffect = styled.div`
  position: absolute;
  inset: 0;
  border: 2px dashed rgba(59, 130, 246, 0.3);
  border-radius: 50%;
  animation: ${spin} 10s linear infinite;
`;

const GearEffect = styled.div`
  position: absolute;
  inset: 0;
  border: 2px solid rgba(59, 130, 246, 0.3);
  border-radius: 50%;
  animation: ${spin} 5s linear infinite;
  
  &::before {
    content: '';
    position: absolute;
    inset: -5px;
    border: 2px dashed rgba(59, 130, 246, 0.2);
    border-radius: 50%;
    animation: ${spin} 3s linear infinite reverse;
  }
`;

const MainContent = styled.main<{ $sidebarOpen: boolean }>`
  flex: 1;
  margin-left: ${props => props.$sidebarOpen ? '280px' : '80px'};
  transition: margin-left 0.3s ease;
  min-height: calc(100vh - 64px);
  padding: 24px;
  overflow-y: auto;
`;






const ContentArea = styled.div`
  flex: 1;
  padding: 24px;
  overflow-y: auto;

  &::-webkit-scrollbar {
    width: 8px;
  }

  &::-webkit-scrollbar-track {
    background: rgba(255, 255, 255, 0.1);
    border-radius: 4px;
  }

  &::-webkit-scrollbar-thumb {
    background: rgba(59, 130, 246, 0.3);
    border-radius: 4px;
    
    &:hover {
      background: rgba(59, 130, 246, 0.5);
    }
  }
`;

const GridLayout = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
  gap: 24px;
  margin-top: 24px;
`;

const Card = styled.div`
  background: rgba(15, 23, 42, 0.8);
  backdrop-filter: blur(12px);
  border-radius: 20px;
  padding: 24px;
  border: 1px solid rgba(255, 255, 255, 0.1);
  animation: ${glow} 3s ease-in-out infinite;
`;

const CardTitle = styled.h2`
  font-size: 1.2rem;
  color: #E2E8F0;
  margin-bottom: 20px;
`;

const ChartContainer = styled.div`
  height: 200px;
  display: flex;
  align-items: flex-end;
  gap: 4px;
`;

const AnimatedChart = styled.div`
  flex: 1;
  height: 100%;
  background: linear-gradient(180deg, #3B82F6 0%, transparent 100%);
  animation: ${chartAnimation} 3s ease-in-out infinite;
`;

const SignalsList = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
`;

const SignalItem = styled.div<{ $delay: number }>`
  display: flex;
  align-items: center;
  gap: 16px;
  padding: 12px;
  background: rgba(59, 130, 246, 0.1);
  border-radius: 12px;
  animation: ${float} 3s ease-in-out infinite;
  animation-delay: ${props => props.$delay}s;
`;

const SignalIcon = styled.span`
  font-size: 1.2rem;
`;

const SignalInfo = styled.div`
  flex: 1;
`;

const SignalName = styled.div`
  font-weight: 500;
  color: #E2E8F0;
`;

const SignalPrice = styled.div<{ $isUp: boolean }>`
  color: ${props => props.$isUp ? '#10B981' : '#EF4444'};
  font-size: 0.9rem;
`;

const SignalIndicator = styled.div<{ $isUp: boolean }>`
  width: 8px;
  height: 8px;
  border-radius: 50%;
  background: ${props => props.$isUp ? '#10B981' : '#EF4444'};
  animation: ${pulse} 2s ease-in-out infinite;
`;


const ButtonGroup = styled.div`
  display: flex;
  gap: 8px;
  align-items: center;
`;

const FavoriteButton = styled.button<{ $isFavorite: boolean }>`
  background: none;
  border: none;
  color: ${props => props.$isFavorite ? '#FFD700' : 'rgba(255, 255, 255, 0.5)'};
  font-size: 1.2rem;
  cursor: ${props => props.disabled ? 'not-allowed' : 'pointer'};
  opacity: ${props => props.disabled ? 0.5 : 1};
  padding: 4px;
  transition: all 0.3s ease;
  
  &:hover {
    transform: ${props => props.disabled ? 'none' : 'scale(1.1)'};
    color: ${props => props.disabled ? 'rgba(255, 255, 255, 0.5)' : '#FFD700'};
  }
`;







const TickerContent = styled.div`
  display: flex;
  gap: 24px;
  animation: ${slide} 20s linear infinite;
`;

const TickerItem = styled.div<{ $delay: number }>`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 4px;
  animation: ${float} 3s ease-in-out infinite;
  animation-delay: ${props => props.$delay}s;
`;

const TickerPrice = styled.span<{ $isUp: boolean }>`
  color: ${props => props.$isUp ? '#10B981' : '#EF4444'};
  font-size: 0.8rem;
  font-weight: 500;
`;

export default DashboardLayout;